// extracted by mini-css-extract-plugin
module.exports = {"root":"AppFooter_root__3XQLk","top":"AppFooter_top__3FN-e","topInner":"AppFooter_topInner__3KjTU","grid":"AppFooter_grid__bJVCT","colGroup":"AppFooter_colGroup__2fo4t"};